var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadlineBorder',{staticClass:"guide_headline"},[_vm._v("役職"),_c('span',[_vm._v("(クリックで詳細が見られます)")])]),_c('SmallCardList',{attrs:{"roleIds":_vm.roleIds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }